export const HISTORY = [
    {
        version: '2018.06.3',
        date: '2018.06.18',
        info: [
            'Bug fix',
            'Added cashback claim history',
            'Improve cashback dashboard'
        ]
    }, {
        version: '2018.04.2',
        date: '2018.04.28',
        info: [
            'Add Featured Stores',
            'Added more stores to the platform',
            'Bug fix'
        ]
    }, {
        version: '2018.03',
        date: '2018.03.25',
        info: [
            'Added instruction page',
            'Added cashback offer each partner stores',
            'Minor UI Improvement',
            'iPhone X bug fix'
        ]
    }, {
        version: '1.1 beta',
        date: '2018.02.25',
        info: [
            'Added Shop-by-Store function',
            'Added Filter functions',
            'Added Search function, and',
            'Minor bug fix'
        ]
    }, {
        version: '1.0 beta',
        date: '2017.12.04',
        info: [
            'QbatesApp released to App Store'
        ]
    }
];


// WEBPACK FOOTER //
// ./src/utils/ios_update_history.js